import React, { Fragment } from 'react';
import { Box, Button, IconButton, Modal, TextField } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

export default function JobPurchaseFormDisable() {
  
  return (

    <Fragment>
      
      <div >
        {/* TITLE AND ID */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 1em 0' }}>
          <p style={{ color: "var(--orange)", fontWeight: '600' }} >Purchase Details</p>
          <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }} >
            <p style={{ margin: '0 0.25em 0 0', fontSize: 'var(--p2)' }} >Transaction ID:</p>
            <p style={{ margin: '0 0.25em 0 0', fontSize: 'var(--p2)' }} >{"-"}</p>
            <IconButton size='small' >
              <ContentCopyOutlinedIcon color='primary' fontSize='small' />
            </IconButton>
          </div>

        </div>

        <div>
          {/* BUYING EMAIL - BOX OFFICE PASSWORD - CREDIT CARD  */}
          <div className="bottom-inputs" style={{ marginBottom: "2em" }}>
            <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
              <label style={{ marginRight: '0.5em' }}>Buying Email Used</label>
              <input
                disabled label="Email Account Used" name="orderNumber" style={{ width: "250px" }}
              />
            </div>

            <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
              <label style={{ marginRight: '1em' }}>Box Office Password Used</label>
              <input
                disabled label="Exchange Update Password" name="exchangeUpdatePass"
              />
            </div>

            <div className="input-column" style={{ margin: "0 2em 1em 0" }}>
              <label style={{ marginRight: '0.5em' }}>Credit Card Used</label>
              <input
                disabled label="Credit Card Used" name="orderNumber" style={{ width: "250px" }}
              />
            </div>

          </div>

          <div className="input-list" style={{ justifyContent: "flex-start" }}>

            <div className="input-column">
              <label>Quantity</label>
              <input
                disabled label="Quantity Purchased" name="quantityPurchashed"
              />
            </div>

            <div className="input-column">
              <label>Section</label>
              <input
                disabled label="Section Purchased" name="sectionPurchashed"
              />
            </div>

            <div className="input-column">
              <label>Row</label>
              <input
                disabled label="Row Purchased" name="rowPurchashed"
              />
            </div>

            <div className="input-column">
              <label>Seats</label>
              <input
                disabled label="Seats Purchased" name="seatsPurchashed"
              />
            </div>

            <div className="input-column">
              <label>Delivery Method</label>
              <input
                id="delivery-method"
                disabled label="Code Used" name="Delivery Method"
              />
            </div>

            <div className="input-column">
              <label>Total Spend </label>
              <input
                disabled label="Total Spend u$s" name="totalSpend"
              />
            </div>

            < div className="input-column">
              <label>Order Number</label>
              <input
                disabled label="Order Number" name="orderNumber"
              />
            </div>

            <div className="input-column">
              <label>Code Used</label>
              <input
                disabled label="Code Used" name="codeUsed"
              />
            </div>

          </div>

        </div>

      </div>

      
      <div style={{ display: 'flex', justifyContent: 'space-between' }} >

        <div >
          {/* CREATE BONUS BUTTON AND MODAL */}
          <Button
            variant='outlined'
            color='success'
            disabled
            onClick={()=>{}}
            sx={{ margin: '0 1em 0 0' }}
          >
            Create Bonus
          </Button>

          {/* CREATE PENALTY BUTTON AND MODAL */}
          <Button
            variant='outlined'
            color='error'
            onClick={()=>{}}
            disabled
          >
            Create Error
          </Button>

        </div>

        <div >
          <Button
            variant='contained'
            color='secondary'
            sx={{ margin: '0 1em 0 0' }}
            disabled
          >
            Cancel Changes
          </Button>

          <Button
            variant='contained'
            disabled
          >
            Save Changes
          </Button>
        </div>

      </div>
    </Fragment >

  )
}